import React from "react";
import { Dropdown, Icon } from "semantic-ui-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import CustomDropdown from "components/CustomDropdown";
import withRoleCheck from "components/hocs/withRoleCheck";
import {
  ArchiveCampaignModal as _ArchiveCampaignModal,
  DeleteCampaignModal as _DeleteCampaignModal,
  EditCampaignModal as _EditCampaignModal,
  ActiveInactiveCampaignModal as _ActiveInactiveCampaignModal,
} from "./components/Modals";
import CONSTANTS from "constants/Constants";
import CampaignService from "services/Campaign";
import { Link } from "react-router-dom";
import {
  deleteCampaign,
  invalidateCampaignsQuery,
} from "hooks/useCampaignTable";

const EditCampaignModal = withRoleCheck(_EditCampaignModal, [
  ACL_RELATIONSHIPS.campaign.edit,
]);
const ArchiveCampaignModal = withRoleCheck(_ArchiveCampaignModal, [
  ACL_RELATIONSHIPS.campaign.edit,
]);
const ActiveInactiveCampaignModal = withRoleCheck(
  _ActiveInactiveCampaignModal,
  [ACL_RELATIONSHIPS.campaign.edit]
);
const DeleteCampaignModal = withRoleCheck(_DeleteCampaignModal, [
  ACL_RELATIONSHIPS.campaign.delete,
]);

const editStatus = async (campaignId, status) => {
  await CampaignService.editStatusInCampaign(campaignId, status);
  await invalidateCampaignsQuery();
};

const activateCampaign = async campaignId => {
  await editStatus(campaignId, 1);
};

const inactivateCampaign = async campaignId => {
  await editStatus(campaignId, 2);
};

const archiveCampaign = async ({ campaignId, status }) => {
  const isArchived = status === CONSTANTS.CAMPAIGN_STATUS_TYPES.ARCHIVED;
  const newStatus = isArchived
    ? CONSTANTS.CAMPAIGN_STATUS_TYPES.ACTIVE
    : CONSTANTS.CAMPAIGN_STATUS_TYPES.ARCHIVED;
  await editStatus(campaignId, newStatus);
};

export const CampaignsTableActions = ({
  campaignId,
  campaignStatus,
  fetchCampaigns,
}) => {
  return (
    <CustomDropdown icon="ellipsis horizontal">
      <Dropdown.Menu direction="left">
        <EditCampaignModal
          campaignId={campaignId}
          fetchCampaigns={fetchCampaigns}
        />
        <DeleteCampaignModal
          onConfirmDelete={() => deleteCampaign(campaignId)}
          menuTrigger
        />
        <ArchiveCampaignModal
          onConfirmArchive={() =>
            archiveCampaign({ campaignId, status: campaignStatus })
          }
          archived={campaignStatus === CONSTANTS.CAMPAIGN_STATUS_TYPES.ARCHIVED}
          menuTrigger
        />
        <ActiveInactiveCampaignModal
          isInactive={
            campaignStatus === CONSTANTS.CAMPAIGN_STATUS_TYPES.INACTIVE
          }
          onConfirmActivate={() => activateCampaign(campaignId)}
          onConfirmInactivate={() => inactivateCampaign(campaignId)}
          disabled={campaignStatus === CONSTANTS.CAMPAIGN_STATUS_TYPES.ARCHIVED}
          menuTrigger
        />
        <Dropdown.Item as={Link} to={"/campaigns/" + campaignId}>
          <Icon name="eye" />
          View
        </Dropdown.Item>
      </Dropdown.Menu>
    </CustomDropdown>
  );
};
